module.exports = __webpack_public_path__ + "static/media/vvns-order-tracking-vivense-cargo-icon.fc1cb332.svg";